/** Registry key for the VhAgentConfig entity. */
export const AGENT_CONFIG = 'VhAgentConfig';
//# sourceMappingURL=agentConfig.js.map